import type { BimActKc2SelectionData } from 'gql/graphql';
import {
    costGroupFormatter,
    dateFormatter,
    GroupManagerCheckboxCellRenderer,
    GroupManagerCheckboxHeaderRenderer,
    GroupNameAndNumberRenderer,
} from 'pages/Project/Common/ActsKC2ListContainer';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useMemo } from 'react';
import type { Control } from 'react-hook-form';

import { chapterFormatter } from '../helpers';

export const useBimActsKc2GroupManagerColumns = ({ control }: { control: Control<any> }) =>
    useMemo<(ColDef<BimActKc2SelectionData> | ColGroupDef<BimActKc2SelectionData>)[]>(
        () => [
            {
                field: 'menu' as any,
                minWidth: 60,
                maxWidth: 60,
                pinned: 'left',
                lockPosition: 'left',
                headerComponent: GroupManagerCheckboxHeaderRenderer,
                cellRenderer: GroupManagerCheckboxCellRenderer,
                cellRendererParams: {
                    control,
                },
                headerComponentParams: {
                    control,
                },
            },
            {
                headerName: 'Номер акта',
                field: 'number',
                cellRenderer: GroupNameAndNumberRenderer,
            },
            {
                headerName: 'Дата акта',
                field: 'actDate',
                valueFormatter: dateFormatter('actDate'),
            },
            {
                headerName: 'Отчетный период',
                marryChildren: true,
                children: [
                    {
                        headerName: 'Начало',
                        field: 'startDate',
                        valueFormatter: dateFormatter('startDate'),
                    },
                    {
                        headerName: 'Окончание',
                        field: 'finishDate',
                        valueFormatter: dateFormatter('finishDate'),
                    },
                ],
            },
            {
                headerName: 'Группа затрат',
                field: 'costGroup',
                valueFormatter: costGroupFormatter,
            },
            {
                headerName: 'Вид стр-ва',
                field: 'constructionType.name',
            },
            {
                headerName: 'Объект',
                field: 'workOrderObjectName',
            },
            {
                headerName: 'Глава расчета',
                field: 'chapter',
                valueFormatter: chapterFormatter,
            },
            {
                headerName: 'Смета',
                marryChildren: true,
                children: [
                    {
                        headerName: 'Шифр',
                        field: 'workOrderPriceCode',
                    },
                    {
                        headerName: 'Наименование',
                        field: 'workOrderPriceName',
                        autoHeight: true,
                        wrapText: true,
                        cellClass: 'wrapping-cell',
                        minWidth: 320,
                    },
                ],
            },
        ],
        [control],
    );
